module.exports = __webpack_public_path__ + "static/img/PIPE_EAGLE_VERTICAL.a99287a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logos/PIPE_EAGLE_VERTICAL.png
// module id = 1634
// module chunks = 6